import React from 'react';
import { PenTool, Film, Zap, Users } from 'lucide-react';

// Sample project data
export const sampleProjects = [
  { name: 'Lunar Odyssey', status: 'on-track', dueDate: '2025-09-30', priority: 'high' },
  { name: 'Forest Whispers', status: 'delayed', dueDate: '2025-08-15', priority: 'medium' },
  { name: 'Ocean Depths', status: 'on-track', dueDate: '2025-11-10', priority: 'high' },
  { name: 'Sky Kingdoms', status: 'at-risk', dueDate: '2025-07-20', priority: 'critical' }
];

// Sample departments with tasks
export const sampleDepartments = [
  {
    name: 'Pre-Production',
    icon: <PenTool size={20} />,
    tasks: [
      { name: 'Script', status: 'completed', progress: 100, assignee: 'Emma Thompson', due: '2025-03-15' },
      { name: 'Storyboard', status: 'completed', progress: 100, assignee: 'Michael Chen', due: '2025-04-10' },
      { name: 'Concept Art', status: 'completed', progress: 100, assignee: 'Sofia Patel', due: '2025-04-25' },
      { name: 'Character Design', status: 'completed', progress: 100, assignee: 'James Wilson', due: '2025-05-05' }
    ]
  },
  {
    name: 'Modeling',
    icon: <Zap size={20} />,
    tasks: [
      { name: 'Character Models', status: 'completed', progress: 100, assignee: 'Lucas Rodriguez', due: '2025-05-20' },
      { name: 'Environment Models', status: 'in-progress', progress: 85, assignee: 'Olivia Kim', due: '2025-05-22' },
      { name: 'Props', status: 'in-progress', progress: 80, assignee: 'Ethan Jackson', due: '2025-05-25' }
    ]
  },
  {
    name: 'Rigging',
    icon: <Users size={20} />,
    tasks: [
      { name: 'Character Rigs', status: 'in-progress', progress: 90, assignee: 'Mia Johnson', due: '2025-05-28' },
      { name: 'Facial Rigs', status: 'in-progress', progress: 75, assignee: 'Noah Williams', due: '2025-06-01' }
    ]
  },
  {
    name: 'Animation',
    icon: <Film size={20} />,
    tasks: [
      { name: 'Scene 1', status: 'in-progress', progress: 65, assignee: 'Ava Martinez', due: '2025-06-10' },
      { name: 'Scene 2', status: 'in-progress', progress: 40, assignee: 'Liam Davis', due: '2025-06-15' },
      { name: 'Scene 3', status: 'not-started', progress: 0, assignee: 'Isabella Brown', due: '2025-06-20' },
      { name: 'Scene 4', status: 'not-started', progress: 0, assignee: 'Oliver Lee', due: '2025-06-25' }
    ]
  },
  {
    name: 'Lighting & Rendering',
    icon: <Zap size={20} />,
    tasks: [
      { name: 'Scene 1 Lighting', status: 'not-started', progress: 0, assignee: 'Charlotte Garcia', due: '2025-07-05' },
      { name: 'Scene 2 Lighting', status: 'not-started', progress: 0, assignee: 'Henry Mitchell', due: '2025-07-10' },
      { name: 'Rendering', status: 'not-started', progress: 0, assignee: 'Amelia Turner', due: '2025-07-15' }
    ]
  },
  {
    name: 'Post-Production',
    icon: <Film size={20} />,
    tasks: [
      { name: 'Compositing', status: 'not-started', progress: 0, assignee: 'William Cooper', due: '2025-07-25' },
      { name: 'VFX', status: 'not-started', progress: 0, assignee: 'Sophie Wright', due: '2025-08-05' },
      { name: 'Sound Design', status: 'not-started', progress: 0, assignee: 'Benjamin Harris', due: '2025-08-15' },
      { name: 'Music', status: 'not-started', progress: 0, assignee: 'Zoe Phillips', due: '2025-08-20' }
    ]
  }
];

// Sample milestones
export const sampleMilestones = {
  'Lunar Odyssey': [
    { name: 'Character Animation Complete', date: '2025-05-22', days: 6 },
    { name: 'Environment Lighting Review', date: '2025-05-30', days: 14 },
    { name: 'Rendering Test', date: '2025-06-15', days: 30 }
  ],
  'Default': [
    { name: 'Animation Review', date: '2025-05-25', days: 9 },
    { name: 'Sound Design Start', date: '2025-06-10', days: 25 }
  ]
};